/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SageSignupControlPage_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly unlinkedSageCustomers: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null;
        } | null> | null;
    } | null;
    readonly missionControlData: {
        readonly sagePSACompanies: ReadonlyArray<{
            readonly id: string;
            readonly companyId: number;
            readonly name: string | null;
            readonly activated: boolean | null;
            readonly workatoCustomerId: string | null;
            readonly createdAt: string | null;
        } | null> | null;
        readonly companiesWithSageEnabled: ReadonlyArray<{
            readonly id: string;
            readonly companyId: number;
            readonly name: string | null;
            readonly activated: boolean | null;
            readonly workatoCustomerId: string | null;
            readonly createdAt: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"MissionControlHeader_viewer">;
    readonly " $refType": "SageSignupControlPage_viewer";
};
export type SageSignupControlPage_viewer$data = SageSignupControlPage_viewer;
export type SageSignupControlPage_viewer$key = {
    readonly " $data"?: SageSignupControlPage_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SageSignupControlPage_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  },
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "activated",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workatoCustomerId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SageSignupControlPage_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UnlinkedSageCustomer",
          "kind": "LinkedField",
          "name": "unlinkedSageCustomers",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlSagePSACompanyType",
          "kind": "LinkedField",
          "name": "sagePSACompanies",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlSagePSACompanyType",
          "kind": "LinkedField",
          "name": "companiesWithSageEnabled",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MissionControlHeader_viewer"
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '530febc4d74808ee44ff8cc3d42a2d67';
export default node;
